import { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Hidden, Paper } from '@mui/material'
import { useLocation } from 'react-router-dom'
import Navigation from './navigation'
import { NavigationType } from '../types'

const NavBar = ({ className, navigation, openMobile, onMobileClose, ...rest }) => {
  const location = useLocation()

  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose()
    }
  }, [location.pathname, openMobile, onMobileClose])

  const navbarContent = (
    <div style={{ padding: '16px' }}>
      <nav style={{ marginTop: '16px' }}>
        {navigation.map(list => (
          <Navigation
            component="div"
            key={list.title}
            pages={list.pages}
            title={list.title}/>
        ))}
      </nav>
    </div>
  )

  return (
    <Fragment>
      <Hidden xsDown>
        <Paper
          {...rest}
          sx={{
            height: '100%',
            overflowY: 'auto',
            ...className
          }}
          elevation={1}
          square>
          {navbarContent}
        </Paper>
      </Hidden>
    </Fragment>
  )
}

NavBar.propTypes = {
  className: PropTypes.object,
  navigation: NavigationType,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
}

export default NavBar
